import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import config from '../../config'
import {
  Link,
  // LinkIcon
} from '../'
import Modal from 'react-modal'
import Styles from './PlanScorecardResultModal.css'

@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardResultModal extends Component {
  static propTypes = {
    iyv: PropTypes.string,
    fund: PropTypes.object,
    notPlan: PropTypes.bool,
  }
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false
    }
  }
  openModal = () =>{
    this.setState({ modalOpen: true })
  }
  closeModal = () =>{
    this.setState({ modalOpen: false })
  }

  render() {
    if (!this.props.iyv || !this.props.fund) {
      return null
    }

    let companies = []

    const redOctagon = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Poor' styleName='red-octagon'/>
        </div>
      </div>
    )
    const yellowSquare = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Fair' styleName='yellow-square'/>
        </div>
      </div>
    )
    const greenCircle = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Good' styleName='green-circle'/>
        </div>
      </div>
    )

    let headline = ''
    let description = ''
    let iconSrc = null
    let iconAlt = ''
    let shape = null
    let url = ''

    const { fund, notPlan } =  this.props

    const { strategy_name } = fund
    const sStrategy = format.sanitize(strategy_name)

    let highlighted_holdings = null
    if (fund.highlighted_holdings) {
      highlighted_holdings = fund.highlighted_holdings
    } else {
      const td = config.targetDateSeries.find(
        (series) => series.strategy_name_query === sStrategy
      )
      highlighted_holdings = td.highlighted_holdings
    }

    const grade_bracket_text = (grade) => {
      if (grade===4 || grade===5) {
        return 'D or F grades'
      } else if (grade===2 || grade===3) {
        return 'B or C grades'
      } else if (grade===1) {
        return 'an A grade'
      }
      return 'Err'
    }

    const rating_bracket_text = (grade) => {
      if (grade===4 || grade===5) {
        return 'poor'
      } else if (grade===2 || grade===3) {
        return 'fair'
      } else if (grade===1) {
        return 'good'
      }
      return 'err'
    }

    const rating_bracket_shape = (grade) => {
      if (grade===4 || grade===5) {
        return redOctagon
      } else if (grade===2 || grade===3) {
        return yellowSquare
      } else if (grade===1) {
        return greenCircle
      }
      return null
    }

    const leadSentence = (
      <div>
        <p>
          {
            notPlan ?
              (
                <span>
                  If your retirement plan offers the <b>{strategy_name}:</b>
                </span>
              ) :
              (
                <span>
                  The target date option for this retirement plan is
                  the <b>{strategy_name}.</b>
                </span>
              )
          }
        </p>
      </div>
    )

    const tryToGetLogo = (_e) => {
      let logo = null
      try {
        logo = require('../../../static/images/cos/'+format.sanitize(_e)+'.png')
      }
      catch (_err) {
        console.log('')
      }
      return logo
    }

    switch (this.props.iyv) {
      //
      //
      //
      case 'fff':
        headline = (
          <div>
            The target date option 2050 fund
            is <span styleName={rating_bracket_text(fund.grade_fossil)}>{format.perc(fund.fossil_fuel_weight,false,1)}</span> invested in fossil
            fuel companies.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, we found <b>{format.perc(fund.fossil_fuel_weight)} invested in fossil fuel companies</b>, including <b>{format.perc(fund.c2_weight,false,1)}</b> in the top 200 carbon reserve owners, and <b>{format.perc(fund.mc50_weight,false,1)}</b> in the top 30 coal-fired utilities.
            </p>
            <p>
              This is assigned a <b>fossil fuel grade of {format.score(fund.grade_fossil)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_fossil)}, we rate that as <b>{rating_bracket_text(fund.grade_fossil)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/fff-icon-white.svg' )
        iconAlt = 'Fossil fuels'
        shape = rating_bracket_shape(fund.grade_fossil)
        companies = highlighted_holdings.fff.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=fossil'
        break
      //
      //
      //
      case 'ffb':
        headline = (
          <div>
            The target date option 2050 fund
            has a score of <span styleName={rating_bracket_text(fund.grade_fossil_bank)}>{format.number(fund.fossil_bank_score, false, false, 2)}</span> for fossil fuel finance.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, the fund has a score of <b>{format.number(fund.fossil_bank_score, false, false, 2)} for fossil fuel finance.</b>
            </p>
            <p>
              This is assigned a <b>fossil fuel finance grade of {format.score(fund.grade_fossil_bank)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_fossil_bank)}, we rate that as <b>{rating_bracket_text(fund.grade_fossil_bank)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/ffb-icon-white.svg' )
        iconAlt = 'Fossil fuel finance'
        shape = rating_bracket_shape(fund.grade_fossil_bank)
        companies = highlighted_holdings.ffb.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=fossil-fuel-lending'
        break
      //
      //
      //
      case 'ffi':
        headline = (
          <div>
            The target date option 2050 fund
            has a score of <span styleName={rating_bracket_text(fund.grade_fossil_insure)}>{format.number(fund.fossil_insure_score, false, false, 2)}</span> for fossil fuel insurance.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, the fund has a score of <b>{format.number(fund.fossil_insure_score, false, false, 2)} for fossil fuel insurance.</b>
            </p>
            <p>
              This is assigned a <b>fossil fuel insurance grade of {format.score(fund.grade_fossil_insure)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_fossil_insure)}, we rate that as <b>{rating_bracket_text(fund.grade_fossil_insure)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/ffi-icon-white.svg' )
        iconAlt = 'Fossil fuel insurance'
        shape = rating_bracket_shape(fund.grade_fossil_insure)
        companies = highlighted_holdings.ffi.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=fossil-fuel-insurance'
        break
      //
      //
      //
      case 'dff':
        headline = (
          <div>
            The target date option 2050 fund
            is <span styleName={rating_bracket_text(fund.grade_deforestation)}>{format.perc(fund.df_p_weight,false,1)}</span> invested in
            deforestation-risk agribusiness producer/traders.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, we found <b>{format.perc(fund.df_p_weight)} invested in deforestation-risk agribusiness producer/traders.</b>
            </p>
            <p>
              This is assigned a <b>deforestation grade of {format.score(fund.grade_deforestation)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_deforestation)}, we rate that as <b>{rating_bracket_text(fund.grade_deforestation)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/dff-icon-white.svg' )
        iconAlt = 'Deforestation'
        shape = rating_bracket_shape(fund.grade_deforestation)
        companies = highlighted_holdings.dff.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=deforestation'
        break
      //
      //
      //
      case 'gef':
        headline = (
          <div>
            The target date option 2050 fund
            is ranked at
            the <span styleName={rating_bracket_text(fund.grade_gender_equality)}>{format.gefScore(fund.gef_grp_norm)}th
            percentile</span> on gender equality.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, we calculated a <b>gender equality score of {format.gefScore(fund.gef_score)} / 100</b> using the Equileap gender equality corporate scorecard. This ranks at the <b>{format.gefScore(fund.gef_grp_norm)}th percentile</b> for the Allocation Funds group.
            </p>
            <p>
              This is assigned a <b>gender equality grade of {format.score(fund.grade_gender_equality)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_gender_equality)}, we rate that as <b>{rating_bracket_text(fund.grade_gender_equality)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/gef-icon-white.svg' )
        iconAlt = 'Gender equality'
        shape = rating_bracket_shape(fund.grade_gender_equality)
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=gender-equality'
        break
      //
      //
      //
      case 'gff':
        headline = (
          <div>
            The target date option 2050 fund
            is <span styleName={rating_bracket_text(fund.grade_guns)}>{format.perc(fund.wff_gun_manufacturers_weight)}</span> invested in gun manufacturers.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, we found <b>{format.perc(fund.wff_gun_manufacturers_weight)} invested in civilian firearm manufacturers</b> and <b>{format.perc(fund.wff_gun_retailers_weight)}</b> invested in firearm retailers.
            </p>
            <p>
              This is assigned a <b>civilian firearm grade of {format.score(fund.grade_guns)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_guns)}, we rate that as <b>{rating_bracket_text(fund.grade_guns)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/gff-icon-white.svg' )
        iconAlt = 'Civilian firearms'
        shape = rating_bracket_shape(fund.grade_guns)
        companies = highlighted_holdings.gff.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=guns'
        break
      //
      //
      //
      case 'pff':
        headline = (
          <div>
            The target date option 2050 fund
            is <span styleName={rating_bracket_text(fund.grade_prison_industrial_complex)}>{format.perc(fund.pff_high_weight,false,1)}</span> invested in high-risk prison and border industry
          companies.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, we found <b>{format.perc(fund.pff_high_weight)} invested in companies with a high risk of involvement in the prison industrial complex</b>, including <b>{format.perc(fund.pff_extreme_weight)}</b> in private prison operators.
            </p>
            <p>
              This is assigned a <b>prison industrial complex grade of {format.score(fund.grade_prison_industrial_complex)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_prison_industrial_complex)}, we rate that as <b>{rating_bracket_text(fund.grade_prison_industrial_complex)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/pff-icon-white.svg' )
        iconAlt = 'Prison industrial complex'
        shape = rating_bracket_shape(fund.grade_prison_industrial_complex)
        companies = highlighted_holdings.pff.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=prison-industrial-complex'
        break
      //
      //
      //
      case 'wff':
        headline = (
          <div>
            The target date option 2050 fund
            is <span styleName={rating_bracket_text(fund.grade_military)}>{format.perc(fund.wff_mil_weight,false,1)}</span> invested in arms manufacturers and military contractors.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, we found <b>{format.perc(fund.wff_mil_weight)} invested in arms manufacturers and military contractors</b>, including <b>{format.perc(fund.wff_nuclear_weapons_weight)}</b> in companies flagged for involvement with nuclear weapons, and <b>{format.perc(fund.wff_cluster_munitions_weight)}</b> in companies flagged involvement with controversial weapons like cluster munitions, anti-personnel landmines, incendiary weapons, and depleted uranium.
            </p>
            <p>
              This is assigned a <b>military weapons grade of {format.score(fund.grade_military)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_military)}, we rate that as <b>{rating_bracket_text(fund.grade_military)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/wff-icon-white.svg' )
        iconAlt = 'Military weapons'
        shape = rating_bracket_shape(fund.grade_military)
        companies = highlighted_holdings.wff.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=military-weapons'
        break
      //
      //
      //
      case 'tff':
        headline = (
          <div>
            The target date option 2050 fund
            is <span styleName={rating_bracket_text(fund.grade_tobacco)}>{format.perc(fund.t_weight,false,1)}</span> invested in tobacco companies.
          </div>
        )
        description = (
          <div>
            {leadSentence}
            <p>
              Using the 2050 fund to represent the series, we found <b>{format.perc(fund.t_weight)} invested in tobacco companies</b>{
                fund.t_m_weight > 0 && fund.t_weight === 0 ?
                  (
                    <span>
                      &nbsp;and <b>{format.perc(fund.t_m_weight)}</b> invested in tobacco-promoting entertainment studios
                    </span>
                  ) :
                  null
              }.
            </p>
            <p>
              This is assigned a <b>tobacco grade of {format.score(fund.grade_tobacco)}.</b> When a retirement plan target date option is assigned {grade_bracket_text(fund.grade_tobacco)}, we rate that as <b>{rating_bracket_text(fund.grade_tobacco)}.</b>
            </p>
          </div>
        )
        iconSrc = require( '../../../static/images/icons/tff-icon-white.svg' )
        iconAlt = 'Tobacco'
        shape = rating_bracket_shape(fund.grade_tobacco)
        companies = highlighted_holdings.tff.map((e,i) => {
          return [tryToGetLogo(e), e]
        })
        url = config.routes.targetDateFunds + '/' + sStrategy + '?issue=tobacco'
        break
      //
      //
      //
      default:
        break
    }

    return (
      <span>
        <span onClick={this.openModal} styleName='modal-opener'>
          {this.props.children}
        </span>

        <Modal
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          contentLabel="Company profile"
          style={{
            overlay : {
              backgroundColor   : 'rgba(0, 0, 0, 0.75)'
            },
            content: {
              position                   : 'absolute',
              top                        : '50%',
              left                       : 0,
              right                      : 0,
              bottom                     : 'auto',
              marginLeft                 : 'auto',
              marginRight                : 'auto',
              width                      : '1000px',
              maxWidth                   : '90%',
              border                     : '0px',
              background                 : '#fff',
              overflow                   : 'visible',
              WebkitOverflowScrolling    : 'touch',
              borderRadius               : 0,
              outline                    : 'none',
              transform                  : 'translateY(-50%)',
              padding                    : 0
            }
          }}>
          <div styleName='family-modal-wrap'>
            <div styleName='family-modal-flex'>
              <div styleName={'family-modal-img img-' + this.props.iyv}>
                <div styleName='family-modal-img-gray'>
                  <div styleName='family-modal-header'>
                    <div styleName='result-lbl-icon-bbl'>
                      <img styleName='result-lbl-icon' src={iconSrc} alt={iconAlt} />
                    </div>
                    <div styleName='result-modal-img-headline'>
                      {headline}
                    </div>
                  </div>
                </div>
              </div>
              <div styleName='family-modal'>
                <div styleName='icons-row-bbl-shape'>
                  <div styleName='result-lbl'>
                    {iconAlt} rating
                  </div>
                  {shape}
                </div>
                <div styleName='family-modal-p'>
                  {description}
                </div>
                <div styleName='icons-row'>
                  {
                    companies.length > 0 ?
                      (
                        <div styleName='company-logos-wrap'>
                          <span style={{
                            whiteSpace: 'nowrap',
                            width: '100%',
                            textAlign: 'left',
                          }}>
                            Invested in:&nbsp;
                          </span>
                          <div styleName='company-logos'>
                            {
                              companies.map((e, i) => {
                                if (e[0]) {
                                  return (
                                    <div
                                      key={'company-logo-'+i}
                                      styleName='company-logo'
                                    >
                                      <img
                                        src={e[0]}
                                        alt={e[1]}
                                      />
                                    </div>
                                  )
                                }
                                return (
                                  <div
                                    key={'company-logo-'+i}
                                    styleName='company-no-logo'
                                  >
                                    {e[1]}
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                      ) :
                      <div />
                  }
                </div>
                {
                  notPlan ?
                    null :
                    <div styleName='more-link'>
                      <Link
                        to={url}
                        title={iconAlt + ' results'}
                        xstrong
                      >
                        More results for {strategy_name}
                      </Link>
                    </div>
                }
              </div>
            </div>
            <div
              styleName='family-modal-close-wrap'
              onClick={this.closeModal}
            >
              <div
                styleName='family-modal-close'
                className='fa fa-times'
              />
            </div>
          </div>
        </Modal>
      </span>
    )
  }
}

